/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Image_Too_LargeInputs */



/**
* | output |
* | --- |
* | "Image too large — 1MB max." |
*
* @param {Promo_Image_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_image_too_large = /** @type {((inputs?: Promo_Image_Too_LargeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Image_Too_LargeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Image trop volumineuse — 1 Mo max.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imagen demasiado grande — 1MB máx.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Imagem muito grande — 1MB máx.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Immagine troppo grande — max 1MB.")
	return /** @type {LocalizedString} */ ("Image too large — 1MB max.")
});